import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import UIStickyFooter from 'UIComponents/panel/UIStickyFooter';
import { getCompareApiNamesSelector } from '../../selectors/CompareSelectors';
import CompareTag from './CompareTag';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { useAppSelector } from '../../reducers';
import breakpoint from '../../constants/Breakpoints';
const Container = styled.div.withConfig({
  displayName: "CompareStatusFooter__Container",
  componentId: "m4f8kb-0"
})(["max-width:1330px;width:100%;margin:auto;margin-top:20px;display:flex;justify-content:space-between;align-items:center;"]);
const ResponsiveButton = styled(UIButton).withConfig({
  displayName: "CompareStatusFooter__ResponsiveButton",
  componentId: "m4f8kb-1"
})(["", ""], breakpoint.hd(_t || (_t = _`
    margin-right: 100px;
  `)));

const CompareStatusFooter = () => {
  const history = useHistory();
  const apiNames = useAppSelector(getCompareApiNamesSelector);

  const handleCompareButtonClick = () => {
    getUsageTracker().track('compareToolInteraction', {
      action: 'clicked compare button',
      productNames: apiNames
    });
    history.push('/compare');
  };

  if (!apiNames.length) return null;
  return /*#__PURE__*/_jsx(UIStickyFooter, {
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: "align-center",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          className: "m-right-8",
          message: "compare.selectToCompare"
        }), apiNames.map(apiName => /*#__PURE__*/_jsx(CompareTag, {
          apiName: apiName
        }, apiName))]
      }), /*#__PURE__*/_jsx(ResponsiveButton, {
        onClick: handleCompareButtonClick,
        use: "tertiary",
        disabled: apiNames.length < 2,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "compare.compareButton"
        })
      })]
    })
  });
};

export default CompareStatusFooter;